import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-sprite-v2',
  templateUrl: './svg-sprite-v2.component.html',
  styleUrls: ['./svg-sprite-v2.component.scss'],  
})
export class SvgSpriteV2Component implements OnInit {
  @Input() hash="";
  @Input() title="";
  @Input() width=36;
  @Input() height=36;
  constructor() { }

  ngOnInit(): void {
  }

}
